import PageSpace from "components/styles/pageSpace";
import useCustomTranslation from "components/Translation/useCustomTranslation";
import HomepageLayout from 'layouts/HomepageLayout.js';

import React, { useEffect } from "react";
import {useHistory} from 'react-router-dom';

import {
  Container,
  Row,
  Col,
} from "reactstrap";


function HomepageView() {
  const history = useHistory();
  const { t } = useCustomTranslation();

  const HandlePageRedirection = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user && user.role === "user") {
      history.push("/personal/trainings/Course")
    }
  }

  useEffect(() => {
    HandlePageRedirection()
  }, [])




  return (
    <>  
      <HomepageLayout/>
      <PageSpace />
      <PageSpace />
      <Container fluid>
        <Row className="mt-8">
          <Col>
              <h2>{t`ValidateCertif`}</h2>           
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default HomepageView;
